import React from "react";

export default () => {
  return (
    <div className="search-results__spinner">
      <img src="/assets/build/img/svg-sprite.svg#loading-squares"/>
    </div>
  );
};